import React, { useEffect, useState } from 'react';
import { initParticlesEngine } from '@tsparticles/react';
import { tsParticles } from '@tsparticles/engine';
import Particles from '@tsparticles/react';
import { motion } from 'framer-motion';
import { FaPhone, FaEnvelope, FaStar, FaArrowRight, FaTimes, FaPaperPlane } from 'react-icons/fa';
import axios from 'axios';

import AZ from '../../assets/logos/az.png';
import C1 from '../../assets/images/MEMBERS-AZYEKOS_01-2.png';
import C2 from '../../assets/images/MEMBERS-AZYEKOS_02-2.png';
import C3 from '../../assets/images/MEMBERS-AZYEKOS_03-1.png';

const CardFidelty = () => {
  const [engineInitialized, setEngineInitialized] = useState(false);
  
  // États pour le modal
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [loading, setLoading] = useState(false);
  const [modalStatus, setModalStatus] = useState({ type: '', message: '' }); // 'success', 'error', ''

  useEffect(() => {
    initParticlesEngine(async (engine) => {
      await tsParticles.loadOptions("tsparticles", {
        fullScreen: { enable: false },
        particles: {
          number: { value: 60 },
          color: { value: "#d8ba72" },
          size: { 
            value: { min: 1, max: 4 },
          },
          move: { 
            enable: true, 
            speed: 1,
            direction: "none",
            random: true,
            out_mode: "out"
          },
          opacity: { 
            value: { min: 0.3, max: 0.7 },
          },
          links: {
            enable: true,
            distance: 150,
            color: "#d8ba72",
            opacity: 0.3,
            width: 1,
          },
          shape: {
            type: "circle",
          }
        },
        interactivity: {
          events: {
            onHover: { 
              enable: true, 
              mode: "bubble",
              parallax: { enable: false, force: 2 }
            },
            resize: true,
          },
          modes: {
            bubble: {
              distance: 200,
              size: 6,
              duration: 0.3,
              opacity: 0.8
            }
          }
        },
        background: { 
          color: "transparent" 
        },
      });
    }).then(() => {
      setEngineInitialized(true);
    });
  }, []);

  // Gestion des changements dans le formulaire
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    // Efface le message de statut quand l'utilisateur modifie le formulaire
    if (modalStatus.message) setModalStatus({ type: '', message: '' });
  };

  // Soumission du formulaire
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setModalStatus({ type: '', message: '' });

    // Validation simple
    if (!formData.name || !formData.email || !formData.message) {
      setModalStatus({ type: 'error', message: 'Veuillez remplir tous les champs.' });
      setLoading(false);
      return;
    }

    // Validation email basique
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      setModalStatus({ type: 'error', message: 'Veuillez entrer une adresse email valide.' });
      setLoading(false);
      return;
    }

    try {
      // Remplacez l'URL par l'endpoint réel de votre API
      const response = await axios.post('/api/send-email', {
        name: formData.name,
        email: formData.email,
        message: formData.message,
      });

      if (response.status === 200 || response.status === 201) {
        setModalStatus({ type: 'success', message: 'Votre message a été envoyé avec succès ! Nous vous répondrons rapidement.' });
        // Réinitialiser le formulaire après succès
        setFormData({ name: '', email: '', message: '' });
        // Optionnel : fermer automatiquement le modal après 3 secondes
        setTimeout(() => {
          setShowModal(false);
          setModalStatus({ type: '', message: '' });
        }, 3000);
      } else {
        throw new Error('Erreur lors de l\'envoi');
      }
    } catch (error) {
      console.error('Erreur API:', error);
      setModalStatus({ type: 'error', message: 'Une erreur est survenue. Veuillez réessayer plus tard.' });
    } finally {
      setLoading(false);
    }
  };

  // Fermeture du modal
  const closeModal = () => {
    setShowModal(false);
    setModalStatus({ type: '', message: '' });
    setFormData({ name: '', email: '', message: '' });
  };

  return (
    <section
      id="contact-section"
      className="contact-section position-relative"
      style={{
        background: "linear-gradient(135deg, #f5e8c8 0%, #d8ba72 100%)",
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        overflow: "hidden",
        position: "relative"
      }}
    >
      {/* Overlay texture */}
      <div style={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundImage: "radial-gradient(#c9ab68 1px, transparent 1px)",
        backgroundSize: "20px 20px",
        opacity: 0.2,
        zIndex: 0
      }}></div>

      {/* Particules */}
      {engineInitialized && (
        <Particles 
          id="tsparticles" 
          className="position-absolute w-100 h-100"
          options={{
            fullScreen: { enable: false },
            particles: {
              number: { value: 60 },
              color: { value: "#d8ba72" },
              size: { 
                value: { min: 1, max: 4 },
              },
              move: { 
                enable: true, 
                speed: 1,
                direction: "none",
                random: true,
                out_mode: "out"
              },
              opacity: { 
                value: { min: 0.3, max: 0.7 },
              },
              links: {
                enable: true,
                distance: 150,
                color: "#d8ba72",
                opacity: 0.3,
                width: 1,
              },
              shape: {
                type: "circle",
              }
            },
            interactivity: {
              events: {
                onHover: { 
                  enable: true, 
                  mode: "bubble",
                  parallax: { enable: false, force: 2 }
                },
                resize: true,
              },
              modes: {
                bubble: {
                  distance: 200,
                  size: 6,
                  duration: 0.3,
                  opacity: 0.8
                }
              }
            },
            background: { 
              color: "transparent" 
            },
          }}
        />
      )}

      <div className="container position-relative z-1 py-5" style={{zIndex: 2}}>
        <div className="text-center mb-5">
          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            style={{
              fontFamily: 'Times, serif',
              fontWeight: 'bold',
              color: '#5c4a1d',
              fontSize: '3.5rem',
              textShadow: '2px 2px 4px rgba(0,0,0,0.1)',
              marginBottom: '1.5rem'
            }}
          >
            CONTACTEZ NOUS !
          </motion.h1>
          
          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ delay: 0.3, duration: 0.7 }}
          >
            <img
              src={AZ}
              alt="logo"
              className="img-fluid"
              style={{ 
                maxWidth: 300,
                filter: 'drop-shadow(0px 5px 15px rgba(0,0,0,0.2))'
              }}
            />
          </motion.div>
         
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.6, duration: 0.7 }}
            style={{
              fontFamily: 'Times, serif',
              color: '#5c4a1d',
              fontSize: '1.5rem',
              marginTop: '1.5rem'
            }}
          >
            Nous sommes à votre écoute
          </motion.p>
        </div>

        <div className="row justify-content-center">
          {/* Carte 1 */}
          <div className="col-md-6 col-lg-4 mb-4">
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
              whileHover={{ y: -10 }}
              className="contact-card"
              style={{
                background: 'rgba(255, 250, 240, 0.9)',
                borderRadius: '15px',
                padding: '2rem',
                textAlign: 'center',
                boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
                border: '1px solid rgba(216, 186, 114, 0.3)',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'
              }}
            >
              <motion.img
                src={C1}
                alt="Contact"
                className="img-fluid mb-4"
                style={{ 
                  maxWidth: 250,
                  borderRadius: '10px',
                  filter: 'drop-shadow(0px 5px 10px rgba(0,0,0,0.15))'
                }}
                whileHover={{ rotate: 2, scale: 1.05 }}
                transition={{ type: "spring", stiffness: 300 }}
              />
              <h3 style={{ 
                fontFamily: 'Times, serif', 
                color: '#5c4a1d',
                marginBottom: '1.5rem'
              }}>
                Rencontrons-nous
              </h3>
              <p style={{ 
                color: '#7a6a3f', 
                marginBottom: '1.5rem',
                flexGrow: 1
              }}>
                Venez discuter de vos projets avec notre équipe
              </p>
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                style={{
                  background: 'linear-gradient(to right, #d8ba72, #c9ab68)',
                  border: 'none',
                  color: '#fff',
                  padding: '0.8rem 2rem',
                  borderRadius: '50px',
                  fontWeight: '600',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                  boxShadow: '0 4px 15px rgba(216, 186, 114, 0.4)'
                }}
              >
                Prendre RDV <FaArrowRight />
              </motion.button>
            </motion.div>
          </div>

          {/* Carte 2 */}
          <div className="col-md-6 col-lg-4 mb-4">
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              whileHover={{ y: -10 }}
              className="contact-card"
              style={{
                background: 'rgba(255, 250, 240, 0.9)',
                borderRadius: '15px',
                padding: '2rem',
                textAlign: 'center',
                boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
                border: '1px solid rgba(216, 186, 114, 0.3)',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'
              }}
            >
              <motion.div
                whileHover={{ scale: 1.05 }}
                transition={{ type: "spring", stiffness: 300 }}
              >
                <a href="tel:+243835593568">
                  <img
                    src={C2}
                    alt="Téléphone"
                    className="img-fluid mb-4"
                    style={{ 
                      maxWidth: 250,
                      borderRadius: '10px',
                      filter: 'drop-shadow(0px 5px 10px rgba(0,0,0,0.15))'
                    }}
                  />
                </a>
              </motion.div>
              <h3 style={{ 
                fontFamily: 'Times, serif', 
                color: '#5c4a1d',
                marginBottom: '1.5rem'
              }}>
                Appelez-nous
              </h3>
              <div style={{ marginBottom: '1.5rem', flexGrow: 1 }}>
                <p style={{ color: '#7a6a3f', marginBottom: '0.5rem' }}>
                  <FaPhone style={{ color: '#d8ba72', marginRight: '0.5rem' }} />
                  <a href="tel:+33483738519" style={{ color: '#7a6a3f', textDecoration: 'none' }}>
                    +33 483 738 519
                  </a>
                </p>
                <p style={{ color: '#7a6a3f' }}>
                  <FaPhone style={{ color: '#d8ba72', marginRight: '0.5rem' }} />
                  <a href="tel:+243835593568" style={{ color: '#7a6a3f', textDecoration: 'none' }}>
                    +243 835 593 568
                  </a>
                </p>
              </div>
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                style={{
                  background: 'linear-gradient(to right, #d8ba72, #c9ab68)',
                  border: 'none',
                  color: '#fff',
                  padding: '0.8rem 2rem',
                  borderRadius: '50px',
                  fontWeight: '600',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                  boxShadow: '0 4px 15px rgba(216, 186, 114, 0.4)'
                }}
              >
                Appeler maintenant <FaArrowRight />
              </motion.button>
            </motion.div>
          </div>

          {/* Carte 3 - MODIFIÉE pour ouvrir le modal */}
          <div className="col-md-6 col-lg-4 mb-4">
            <motion.div
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, delay: 0.4 }}
              whileHover={{ y: -10 }}
              className="contact-card"
              style={{
                background: 'rgba(255, 250, 240, 0.9)',
                borderRadius: '15px',
                padding: '2rem',
                textAlign: 'center',
                boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
                border: '1px solid rgba(216, 186, 114, 0.3)',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'
              }}
            >
              <motion.div
                whileHover={{ scale: 1.05 }}
                transition={{ type: "spring", stiffness: 300 }}
              >
                <img
                  src={C3}
                  alt="Email"
                  className="img-fluid mb-4"
                  style={{ 
                    maxWidth: 250,
                    borderRadius: '10px',
                    filter: 'drop-shadow(0px 5px 10px rgba(0,0,0,0.15))',
                    cursor: 'pointer'
                  }}
                  onClick={() => setShowModal(true)}
                />
              </motion.div>
              <h3 style={{ 
                fontFamily: 'Times, serif', 
                color: '#5c4a1d',
                marginBottom: '1.5rem'
              }}>
                Écrivez-nous
              </h3>
              <p style={{ 
                color: '#7a6a3f', 
                marginBottom: '1.5rem',
                flexGrow: 1
              }}>
                Envoyez-nous un email pour toute demande
              </p>
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                style={{
                  background: 'linear-gradient(to right, #d8ba72, #c9ab68)',
                  border: 'none',
                  color: '#fff',
                  padding: '0.8rem 2rem',
                  borderRadius: '50px',
                  fontWeight: '600',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                  boxShadow: '0 4px 15px rgba(216, 186, 114, 0.4)'
                }}
                onClick={() => setShowModal(true)}
              >
                Envoyer un email <FaArrowRight />
              </motion.button>
            </motion.div>
          </div>
        </div>

        {/* Section supplémentaire */}
        <motion.div 
          className="text-center mt-5 pt-4"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.8, duration: 0.7 }}
          style={{
            borderTop: '1px solid rgba(216, 186, 114, 0.3)',
            paddingTop: '2rem'
          }}
        >
          <h3 style={{ 
            fontFamily: 'Times, serif', 
            color: '#5c4a1d',
            marginBottom: '1rem'
          }}>
            Pourquoi nous choisir ?
          </h3>
          <div className="row justify-content-center">
            <div className="col-md-3 col-6">
              <div style={{ padding: '1rem' }}>
                <FaStar style={{ color: '#d8ba72', fontSize: '2rem', marginBottom: '1rem' }} />
                <p style={{ color: '#7a6a3f', fontWeight: '500' }}>Service Premium</p>
              </div>
            </div>
            <div className="col-md-3 col-6">
              <div style={{ padding: '1rem' }}>
                <FaStar style={{ color: '#d8ba72', fontSize: '2rem', marginBottom: '1rem' }} />
                <p style={{ color: '#7a6a3f', fontWeight: '500' }}>Expertise Professionnelle</p>
              </div>
            </div>
            <div className="col-md-3 col-6">
              <div style={{ padding: '1rem' }}>
                <FaStar style={{ color: '#d8ba72', fontSize: '2rem', marginBottom: '1rem' }} />
                <p style={{ color: '#7a6a3f', fontWeight: '500' }}>Élégance et Confort</p>
              </div>
            </div>
            <div className="col-md-3 col-6">
              <div style={{ padding: '1rem' }}>
                <FaStar style={{ color: '#d8ba72', fontSize: '2rem', marginBottom: '1rem' }} />
                <p style={{ color: '#7a6a3f', fontWeight: '500' }}>Disponibilité 24/7</p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>

      {/* MODAL - Formulaire d'envoi d'email */}
      {showModal && (
        <div 
          className="modal-overlay"
          onClick={closeModal}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.6)',
            backdropFilter: 'blur(4px)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
            padding: '1rem'
          }}
        >
          <motion.div 
            className="modal-container"
            initial={{ opacity: 0, scale: 0.9, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.9, y: 20 }}
            transition={{ type: 'spring', damping: 25, stiffness: 300 }}
            onClick={(e) => e.stopPropagation()}
            style={{
              backgroundColor: '#fffef7',
              borderRadius: '20px',
              maxWidth: '500px',
              width: '100%',
              position: 'relative',
              boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
              border: '1px solid rgba(216, 186, 114, 0.5)',
              overflow: 'hidden'
            }}
          >
            {/* En-tête du modal */}
            <div style={{
              padding: '1.5rem 2rem',
              background: 'linear-gradient(135deg, #f5e8c8 0%, #d8ba72 100%)',
              borderBottom: '1px solid rgba(216, 186, 114, 0.3)',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}>
              <h3 style={{
                fontFamily: 'Times, serif',
                color: '#5c4a1d',
                margin: 0,
                fontSize: '1.5rem',
                fontWeight: 'bold'
              }}>
                Envoyez-nous un message
              </h3>
              <button
                onClick={closeModal}
                style={{
                  background: 'none',
                  border: 'none',
                  fontSize: '1.5rem',
                  cursor: 'pointer',
                  color: '#5c4a1d',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: '0.5rem',
                  borderRadius: '50%',
                  transition: 'all 0.2s',
                  width: '36px',
                  height: '36px'
                }}
                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'rgba(0,0,0,0.05)'}
                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
              >
                <FaTimes />
              </button>
            </div>

            {/* Corps du formulaire */}
            <form onSubmit={handleSubmit} style={{ padding: '2rem' }}>
              <div style={{ marginBottom: '1.5rem' }}>
                <label style={{
                  display: 'block',
                  marginBottom: '0.5rem',
                  color: '#5c4a1d',
                  fontWeight: '600',
                  fontFamily: 'sans-serif'
                }}>
                  Nom complet *
                </label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  style={{
                    width: '100%',
                    padding: '0.75rem 1rem',
                    border: '1px solid #e2d5b6',
                    borderRadius: '12px',
                    fontSize: '1rem',
                    backgroundColor: '#fff',
                    transition: 'border 0.2s',
                    outline: 'none'
                  }}
                  onFocus={(e) => e.target.style.borderColor = '#d8ba72'}
                  onBlur={(e) => e.target.style.borderColor = '#e2d5b6'}
                />
              </div>

              <div style={{ marginBottom: '1.5rem' }}>
                <label style={{
                  display: 'block',
                  marginBottom: '0.5rem',
                  color: '#5c4a1d',
                  fontWeight: '600',
                  fontFamily: 'sans-serif'
                }}>
                  Email *
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  style={{
                    width: '100%',
                    padding: '0.75rem 1rem',
                    border: '1px solid #e2d5b6',
                    borderRadius: '12px',
                    fontSize: '1rem',
                    backgroundColor: '#fff',
                    transition: 'border 0.2s',
                    outline: 'none'
                  }}
                  onFocus={(e) => e.target.style.borderColor = '#d8ba72'}
                  onBlur={(e) => e.target.style.borderColor = '#e2d5b6'}
                />
              </div>

              <div style={{ marginBottom: '1.5rem' }}>
                <label style={{
                  display: 'block',
                  marginBottom: '0.5rem',
                  color: '#5c4a1d',
                  fontWeight: '600',
                  fontFamily: 'sans-serif'
                }}>
                  Message *
                </label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows="5"
                  style={{
                    width: '100%',
                    padding: '0.75rem 1rem',
                    border: '1px solid #e2d5b6',
                    borderRadius: '12px',
                    fontSize: '1rem',
                    backgroundColor: '#fff',
                    resize: 'vertical',
                    fontFamily: 'sans-serif',
                    transition: 'border 0.2s',
                    outline: 'none'
                  }}
                  onFocus={(e) => e.target.style.borderColor = '#d8ba72'}
                  onBlur={(e) => e.target.style.borderColor = '#e2d5b6'}
                />
              </div>

              {/* Message de statut */}
              {modalStatus.message && (
                <div style={{
                  marginBottom: '1.5rem',
                  padding: '0.75rem',
                  borderRadius: '12px',
                  backgroundColor: modalStatus.type === 'success' ? '#d4edda' : '#f8d7da',
                  color: modalStatus.type === 'success' ? '#155724' : '#721c24',
                  border: `1px solid ${modalStatus.type === 'success' ? '#c3e6cb' : '#f5c6cb'}`,
                  fontSize: '0.9rem',
                  textAlign: 'center'
                }}>
                  {modalStatus.message}
                </div>
              )}

              {/* Bouton d'envoi */}
              <button
                type="submit"
                disabled={loading}
                style={{
                  width: '100%',
                  background: 'linear-gradient(to right, #d8ba72, #c9ab68)',
                  border: 'none',
                  color: '#fff',
                  padding: '0.9rem',
                  borderRadius: '50px',
                  fontWeight: 'bold',
                  fontSize: '1rem',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '0.75rem',
                  cursor: loading ? 'not-allowed' : 'pointer',
                  opacity: loading ? 0.7 : 1,
                  transition: 'transform 0.2s, box-shadow 0.2s',
                  boxShadow: '0 4px 12px rgba(216, 186, 114, 0.3)'
                }}
                onMouseEnter={(e) => {
                  if (!loading) e.currentTarget.style.transform = 'translateY(-2px)';
                }}
                onMouseLeave={(e) => {
                  if (!loading) e.currentTarget.style.transform = 'translateY(0)';
                }}
              >
                {loading ? (
                  'Envoi en cours...'
                ) : (
                  <>
                    Envoyer <FaPaperPlane />
                  </>
                )}
              </button>
            </form>
          </motion.div>
        </div>
      )}

      <style>
        {`
          .contact-card {
            transition: all 0.3s ease;
          }
          
          .contact-card:hover {
            transform: translateY(-10px);
            box-shadow: 0 15px 35px rgba(0,0,0,0.15) !important;
          }
          
          @media (max-width: 768px) {
            .contact-section h1 {
              font-size: 2.5rem !important;
            }
          }

          /* Animation d'entrée du modal */
          @keyframes modalFadeIn {
            from {
              opacity: 0;
              transform: scale(0.95);
            }
            to {
              opacity: 1;
              transform: scale(1);
            }
          }
        `}
      </style>
    </section>
  );
};

export default CardFidelty;